import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Accommodation = () => {
  const show = false;
  if (show) {

    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2025" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">

            <div className="announce">
              <h2>The information is to be announced. </h2>
            </div>

          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2025" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content1">
            <h1>ICSI 2025 Recommended Hotels</h1>

            <div className="hotel">
              <h2>KEIKYU EX HOTEL MINATOMIRAI YOKOHAMA</h2>
              <div className="gallery">
                <img src="./images/hotel/dd61f15d.webp" width={600} alt="Exterior view"/>
                  <img src="./images/hotel/77d8161a.avif" width={600} alt="Modern room"/>
                  </div>
                  <div className="details">
                    <p><strong>Address:</strong> 4-3-6 Minatomirai, Nishi-ku, Yokohama (3-minute walk from Shin-Takashima Station)</p>
                    <p><strong>Key Features:</strong></p>
                    <ul>
                      <li>Panoramic city views from rooms</li>
                      <li>Free Wi-Fi and 24-hour convenience store</li>
                      <li>Connected to KT Zepp Yokohama concert venue</li>
                    </ul>
                    <a href="https://www.tokyuhotels.co.jp/yokohama-r/" className="button" >Official Site</a>
                  </div>
              </div>


              <div className="hotel">
                <h2>The Square Hotel Yokohama Minatomirai</h2>
                <div className="gallery">
                  <img src="./images/hotel/71305ea9.avif" width={600}/>
                    <img src="./images/hotel/4dc0fc10.webp" alt="Bay view" width={600}/>
                    </div>
                    <div className="details">
                      <p><strong>Address:</strong> Minatomirai 2-chome area (1-minute walk from Minatomirai Station)</p>
                      <ul>
                        <li>Direct access to shopping complexes</li>
                        <li>15-minute walk to Landmark Tower</li>
                        <li>Modern Italian restaurant on-site</li>
                      </ul>
                      <a href="https://www.mgphotels.com" className="button" >Book Now</a>
                    </div>
                </div>

                <div className="hotel">
                  <h2>Mitsui Garden Hotel Yokohama Minatomirai PREMIER</h2>
                  <div className="gallery">
                    <img src="./images/hotel/031.jpg" alt="Hotel entrance" width={600}/>
                      <img src="./images/hotel/032.jpg" alt="Guest room" width={600}/>
                      </div>
                      <div className="details">
                        <p><strong>Address:</strong> 3-3-3 Minato Mirai, Nishi-ku, Yokohama, Kanagawa 220-0012(5-min walk from Minatomirai Station)</p>
                        <ul>
                          <li>Sky Pool & Restaurant</li>
                          <li>Panoramic city and bay views</li>
                          <li>Close to major attractions</li>
                        </ul>
                        <a href="https://www.gardenhotels.co.jp/yokohama-minatomirai-premier/eng/" className="button" >Official Site</a>
                      </div>
                  </div>

                  <p><em>All hotels are within 15–20 minutes by train to Kanagawa University.</em></p>
                </div>
                
                <div>
                  {/* <h2>The information is to be announced. </h2> */}

                </div>
              </EmptyTwo>
              {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
              <Footer />
              <ScrollToTop />
            </React.Fragment>
            );
  }
};

            export default Accommodation;
